import * as types from './constants';

// Create Regularusers Group
export const createRegularusersGroupRequest = data => (
  { type: types.CREATE_REGULARUSERS_GROUP_REQUEST, payload: data }
);

export const createRegularusersGroupDone = data => (
  { type: types.CREATE_REGULARUSERS_GROUP_DONE, payload: data }
);

export const createRegularusersGroupFailed = errors => (
  { type: types.CREATE_REGULARUSERS_GROUP_FAILED, payload: errors }
);